<template>
<div class="container-fluid" >
  
  
  <div class="row">
    
     <div class="col">
      
    </div>

    <div class="col-md-6">
      
      <form id="New" v-on:submit.prevent="submit()">

        <div class="card border-success text-white mb-3">
          <div  class="card-header bg-success">
            <h4><i  class="fas fa-edit mr-2" aria-hidden="true"></i>NUOVO DOCUMENTO DI CARICO (DDT/FATTURA)</h4>
          </div>
          <div style="color:black" class="card-body">
            <div class="form-group">
              <h4 style="color:blue"><strong> {{supplier}}</strong></h4>
              <!--<supplier-select v-bind:isActive="false" v-bind:Id="doc.supplierId"></supplier-select>-->  
            </div>

            <collectionSelect  v-bind:props="collection" @update="setCollectionId"></collectionSelect>                
            <collectionOptionType v-bind:typeId="collection.typeId" @update="setCollectionTypeId"></collectionOptionType>  

            <div class="form-group mt-4">
              <label for="doc_type"><strong>Tipo documento</strong></label>
              <select required v-model="doc.typeId" class="form-control bold" id="doc_type">
                <option value="1">Fattura</option>
                <option value="2">DDT</option>
          
              </select>
            </div>
            <div class="form-group">
              <label for="number_doc"><strong>Numero documento</strong></label>
              <input v-model="doc.number" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" required>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
            <div class="form-group">
              <label for="date_doc"><strong>Data documento</strong></label>
              <input required v-model="doc.date" type="date" class="form-control bold" placeholder="" name="date_doc" id = "date_doc">
            </div>
            <div class="form-group">
                <store-select @update="setStoreId" v-bind:required="true" v-bind:isActive="true"></store-select>
              
            </div>
          </div>
        </div>
        
        <button :disabled="bt_spinner" type="submit"   class="btn btn-primary float-right mt-1 mb-2 mr-2">                    
          PROCEDI
          <i class="fas fa-chevron-circle-right ml-2 mr-2" aria-hidden="true"></i>
          
           <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </button>       
      </form>

      
    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>
        <h4>{{cb.msg2}}</h4>
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>  

    

    </div>

     <div class="col">
      
    </div>

  </div>



<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


<!-- MAIN DIV -->
</div>

</template>
<script>

//import supplierSelect from '@/components/common/SupplierSelect.vue'
import storeSelect    from '@/components/common/StoreSelect.vue'
import api            from '@/api'
import confirmBox     from '@/components/common/ConfirmBox.vue'

import alertBox       from '@/components/common/AlertBox.vue'

import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 


import { mapGetters } from 'vuex'
export default {
  
  components: {storeSelect,confirmBox,alertBox,collectionSelect,collectionOptionType},  
  props: ['_doc','supplier'],
  data () {
    return {
            
     
      doc             : this._doc,    
      bt_spinner      : false,
      options         : [],          
      cb              : {title : '',msg1 : '',show:false},
      msg             : {title : '',body:'',type :0},
    
      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1


      },
      

    }
  },

computed: 
  {
    ...mapGetters(['company']), 

  },
created()
{


  this.doc.collectionTypeId = 1
  

},
methods: 
{   
  

  setCollectionId(Id)
    {
      
      this.collection.Id = Id
      this.doc.collectionId = Id
      

    },
    setCollectionTypeId(Id)
    {
      this.collection.typeId = Id
      this.doc.collectionTypeId = Id
    },
    
  setStoreId(Id,stores)
  {
    

    this.doc.storeId = Id
   
    stores.forEach(item => {
      if(item.storeId == Id)
      {
        this.doc.store = item.store
      }
    });

  },  

  processModal()
  {
    
    this.cb.show = false    
    this.$emit('update',this.doc)
  
  },

 
  async submit() 
  {
  
    this.msg.title = ''
   
    this.bt_spinner = true
    const data  = {'ownerType'  :'S',
                   'supplierId' : this.doc.supplierId,
                   'number'     : this.doc.number,
                   'date'       : this.doc.date,
                   'typeId'     : this.doc.typeId,
                   'storeId'    : this.doc.storeId,
                   'companyId'  : this.company.Id}       

    this.cb.title  = ''
    this.cb.msg1   = '' 
    this.cb.msg2   = ''
        
    const sp   = {'sp':'spDocumentSupplier'}
    const json = Object.assign(data, sp);
   
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              const item = res.data.recordsets[0]
              if(item.length > 0)
              {
                              
                  this.cb.title = "DOCUMENTO DI ACQUISTO ESISTENTE."
                  this.cb.msg1 = 'Creato il ' + item[0].create_at
                  this.cb.msg2 = 'PROCEDO ?'
                  this.doc.documentId = item[0].documentId
                  this.doc.movementId = item[0].stockMovementId                
                  
              }
              else
              {
                
                this.doc.documentId = null
                this.doc.movementId = null

                this.cb.title = 'NUOVO DOCUMENTO DI ACQUISTO.'
                this.cb.msg1  = 'SI DESIDERA PROCEDERE ?' 

              }
              this.cb.show = true 
                 

            }
            else if(res.status==500)
            {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type = 1
                
                    
           } 
           else
            {
              
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type = 1 
            } 
          

          }).catch(err => {
              
              
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = err.message
                this.msg.type = 1 
              
          }).finally(() => {
          this.bt_spinner = false
        });

	}
  
      
}
    
}    
</script>

<style scoped>




 
.bold {
  font-weight: bolder;
}

h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
}



</style>